import React, {useState, useEffect,useMemo} from "react";
import {useLoader}                          from "components/Covers/loadingCover";
import {InputGeneral}                       from "components/Field/field";
import Style                                from "components/UI/main.module.scss";
import  {   //  Cicle
            getCycleList,
            getCycleByID,
            updateCycle,
            updateCycleStatus,
            deleteCycle,
            updateCyclePeriod,
            deleteCyclePeriod,  
            //  Period
            getPeriodLabelList,        
            getPeriodLabelByID,
            updatePeriodLabel,
            updatePeriodLabelStatus,
            deletePeriodLabel,                   
        }                                   from "./configService";
import  {   q3x_FunData, 
            GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            SpinnerSmall,
            ValidateBusinessRules,
        }                                   from "Utilities/utils";
import  {   DatePicker,
            DateToIsoString,
            DateFromIsoString,
            setDefaultInitDate,
            setDefaultFinalDate,
            compareInitFinDate,
            DisplayGridDatetime,
            getDateNow,
        }                                   from "components/Date/date";       
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { useSideContent }                   from "components/SideContent/sideContent";
import {ModalContentGoAction, ModalContent} from "components/Modal/modal";
import {TableGrid}                          from "components/Table/table";
import {SearchableDropdownList}             from "components/DropdownListField/dropdownListFIeld";
import {AccordionIcon}                      from "components/Accordion/accordion";
import  {   StatusFilter}                   from "components/Filter/statusFilter";
import  {   NeedSaveBlock}                  from "components/Validation/needSaveBlock";
import  {   useEditDraftAutoSave,
            takeEditDraft,
            clearEditDraft,
        }                                   from "Utilities/editDraft";
import  {   getSystemStatusList}            from "Services/service";
import { AccessDeniedContent } from "components/Content/accessContent";

let blank_cycle_obj                 = {
    NeedSave:           false,
    CycleId:            0,
    CycleYear:          0,
    StatusId:           1,
    CycleName:          "",
    CycleObservation:   "",
    CyclePeriods:       [],
};
let blank_cycle_period_obj          = {
    NeedSave:               false,
    CycleId:                0,
    CyclePeriodId:          0,
    PeriodLabelId:          0,
    PeriodStatusId:         1,
    StartDate:              setDefaultInitDate(),
    EndDate:                setDefaultFinalDate(),
    CyclePeriodName:        "",
    CyclePeriodObservation: "",
};
let blank_period_label_obj          = {
    NeedSave:           false,
    PeriodLabelId:      0,
    PeriodLabelNamePt:  "",
    PeriodLabelNameEn:  "",
    PeriodLabelNameEs:  "",
    StatusId:           1,
};

const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
}; 
//#region   Period Content          
const PeriodEditBtn                 = React.memo((props) => {
    const { 
        setIsLoading,
        fetchPeriodLabelList,
    }                                   = props.context;
    const { data }                      = props;
    const { showSideContent }           = useSideContent();    
    const { showModal, hideModal}       = useModal();

    const fetchPeriodLabelData                = async (itemId) => {
        try {
            let payload = await getPeriodLabelByID({ PeriodLabelId: itemId });
            if (payload?.Status?.Code === 0) {
                return payload.Response.Content;
            } 
            else {
                showModal(<ModalContent Message={payload?.Status?.Message || "Error"} />);
                return null;
            }
        } 
        catch (error) {
            return null;
        }
    };
    const handleEditClick               = async () => {
        setIsLoading(true);
        const obj = await fetchPeriodLabelData(data.PeriodLabelId);
        if (obj) {
            showSideContent({
                component: PeriodEdit,
                props: {
                    fetchPeriodLabelList: fetchPeriodLabelList,
                    PeriodLabelData: obj,
                },
                overlay: true,
            });                 
        }
        setIsLoading(false);
    };
    return(
        <div onClick={handleEditClick} className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"className={[Style.small_ico_generic].join(" ")}>
                <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
            </svg>
        </div>
    );    
});
const PeriodEdit                    = React.memo(({...setProps}) => {
    const {
        fetchPeriodLabelList,
        PeriodLabelData,
    }                                                   = setProps;
    const [ isLoading,          setIsLoading]           = useState(true);
    const [ periodLabelObj,     setPeriodLabelObj]      = useState(null);
    const { showToastMessage}                           = useToastMessage();
    const { showSideContent,    hideSideContent}        = useSideContent();
    const { showModal,          hideModal}              = useModal();
    const draftKey                                       = `PeriodEdit-${PeriodLabelData?.PeriodLabelId ?? 0}`;

    useEditDraftAutoSave({
        draftKey,
        data:     periodLabelObj,
        needSave: periodLabelObj?.NeedSave,
    });

    const handleSave        = async ()  => {
        setIsLoading(true);
        let payload = await updatePeriodLabel(periodLabelObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                setPeriodLabelObj(prev => ({
                    ...prev,
                    NeedSave: false,
                    PeriodLabelId: payload.Response.Content.PeriodLabelId,
                }));
                clearEditDraft();
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction        = async ()  => {
        let messages = [];
        if (periodLabelObj?.PeriodLabelNamePt?.length === 0   || periodLabelObj?.PeriodLabelNamePt === null || periodLabelObj?.PeriodLabelNamePt === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (messages.length > 0) {
            showModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await fetchPeriodLabelList();
        }
    };
    const handleDelete      = async ()  => {
        setIsLoading(true);
        let payload = await deletePeriodLabel(periodLabelObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction      = async ()  => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {                
                    hideModal();
                    await handleDelete();
                    await fetchPeriodLabelList();
                    await hideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp         = periodLabelObj;
        tmp.StatusId    = (tmp.StatusId === 1) ? 2 : 1;
        let payload     = await updatePeriodLabelStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setPeriodLabelObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await hideModal();
                    await handleStatus();
                    await fetchPeriodLabelList();
                }}
            />
        );
    };        

    useEffect(() => {
        if (PeriodLabelData) {
            const obj = PeriodLabelData;
            const draft = takeEditDraft(`PeriodEdit-${obj?.PeriodLabelId ?? 0}`);
            setPeriodLabelObj(prev => {
                return({
                    ...prev,
                    ...obj,
                    ...(draft ?? {}),
                });
            });
        }
        else {
            const draft = takeEditDraft(`PeriodEdit-${blank_period_label_obj?.PeriodLabelId ?? 0}`);
            setPeriodLabelObj({...blank_period_label_obj, ...(draft ?? {})});
        }
        setIsLoading(false);
    }, [PeriodLabelData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={periodLabelObj?.NeedSave}/>
                    {/* Name Pt*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Portuguese")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={periodLabelObj?.PeriodLabelNamePt}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setPeriodLabelObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            PeriodLabelNamePt : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{periodLabelObj?.PeriodLabelNamePt?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>

                    {/* Name En*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("English")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={periodLabelObj?.PeriodLabelNameEn}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setPeriodLabelObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            PeriodLabelNameEn : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{periodLabelObj?.PeriodLabelNameEn?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>     

                    {/* Name Es*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Name")} {GetSystemLabel("Spanish")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={periodLabelObj?.PeriodLabelNameEs}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setPeriodLabelObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            PeriodLabelNameEs : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Name")}
                                maxLength={50}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{periodLabelObj?.PeriodLabelNameEs?.length} {GetSystemLabel("of")} 50 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                                   
                    
                    <div className={[Style.py_5, Style.border_bottom].join(" ")}/>                            
                    
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((periodLabelObj.PeriodLabelId !== null) && (periodLabelObj.PeriodLabelId !== undefined) && (periodLabelObj.PeriodLabelId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {periodLabelObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>                
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );
});
const PeriodContent                 = React.memo(({...setProps}) => {
    const { ContentType,
            StatusList,
            SearchStatus,
            SetSearchStatus,
     }                           = setProps;
    // Mount State                
    const [isReady, setIsReady]                     = useState(false);     
    // Loading State                  
    const [ isLoading,  setIsLoading]               = useState(true);  
    const [rowData,     setRowData]                 = useState([]);   
    const [searchText,  setSearchText]              = useState('');
    const { showSideContent}                        = useSideContent();    
    const { showModal}                              = useModal();

    const fetchPeriodLabelList      = async () => {
        try {
            let payload = await getPeriodLabelList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const gridContext               = useMemo(() => ({
        isLoading,
        setIsLoading,
        fetchPeriodLabelList: fetchPeriodLabelList,
    }), []);

    const columnDefs                = useMemo(() => [
        {
            headerName: GetBusinessLabel("TableHeaderPeriodLabel"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("Edit"),                     field: GetSystemLabel("Edit")                     ,cellRenderer: PeriodEditBtn, cellClass: [Style.table_text_center].join(" "), headerClass: Style.table_header_center, flex: 0,},
                { hide: false,lockVisible: true,                         headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Portuguese")}`,                       field: `PeriodLabelName${GetAppLang()}`            ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,                         headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("English")}`,                          field: `PeriodLabelName${GetAppLang()}`            ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true,                         headerName: `${GetSystemLabel("Name")} ${GetSystemLabel("Spanish")}`,                          field: `PeriodLabelName${GetAppLang()}`            ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`    ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}  ,
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),              field: "PeriodLabelId"              ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                          headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },             
    ].filter(Boolean), []);    

    const NewItem                   = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_period_label_obj));
        showSideContent({
            component: PeriodEdit,
            props: {
                fetchPeriodLabelList: fetchPeriodLabelList,
                PeriodLabelData: obj_copy,
            },
            overlay: true,
        }); 
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchPeriodLabelList();
        }
    }, [ContentType, isReady]);


    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("PeriodLabelPageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchPeriodLabelList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>                            
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                    
                        </div>
                    </div>         
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                gridContext={gridContext}
                            />                     
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
});
//#endregion
//#region   Cycle Content           
const CycleEditBtn                  = React.memo((props) => {
    const { 
        StatusList, 
        periodLabelList,
        setIsLoading,
        fetchCycleList,
    }                                   = props.context;
    const { data }                      = props;
    const { showSideContent }           = useSideContent();    
    const { showModal       }           = useModal();    
    const fetchCycleData                = async (cycleId) => {
        try {
            let payload = await getCycleByID({ CycleId: cycleId });
            if (payload?.Status?.Code === 0) {
                return payload.Response.Content;
            } 
            else {
                showModal(<ModalContent Message={payload?.Status?.Message || "Error"} />);
                return null;
            }
        } 
        catch (error) {
            return null;
        }
    };
    const handleEditClick               = async () => {
        setIsLoading(true);
        const obj = await fetchCycleData(data.CycleId);
        if (obj) {
            showSideContent({
                component: CycleEdit,
                props: {
                    fetchCycleList: fetchCycleList,
                    StatusList: StatusList, 
                    PeriodLabelList: periodLabelList,
                    CycleData: obj,
                },
                overlay: true,
            });
        }
        setIsLoading(false);
    };
    
    useEffect(() => {}, [data, StatusList, periodLabelList,setIsLoading,fetchCycleList,]);

    return(
        <>
            <div 
                onClick={handleEditClick} 
                className={[Style.icon, Style.clickable, Style.shadow_sm, Style.p_1, Style.text_center].join(" ")}>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 512 512"
                    className={[Style.small_ico_generic].join(" ")}
                >
                    <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                </svg>
            </div>
        </>
    );    
});
const CyclePeriodEdit               = React.memo(({...setProps}) => {
    const {
        Index,
        CyclePeriodData,
        SetCyclePeriodData,
        StatusList,
        PeriodLabelList,
        Remove,
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);
    const [ isLoadingChild,  setIsLoadingChild]                  = useState(false);
    const { showToastMessage            }                        = useToastMessage();
    const [isOpen,           setIsOpen]                          = useState(false);
    const { showModal, hideModal}                                = useModal();        

    const toogleOpen = () => {
        setIsOpen(prev => !prev);
    };

    const handleChange = ({ field, value }) => {
        SetCyclePeriodData(prevState => {
            const updatedItems = prevState.CyclePeriods.map((item, i) => {
                if (i === Index) {
                    return {
                        ...item,
                        [field]: value,
                    };
                }
                return item;
            });
            return {
                ...prevState,
                CyclePeriods: updatedItems,
            };
        });
    };

    const handleSave = async () => {
        if (CyclePeriodData?.CycleId !== 0 && CyclePeriodData?.CyclePeriodId !== 0) {
            setIsLoadingChild(true);
            let payload = await updateCyclePeriod(CyclePeriodData);
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    handleChange("CyclePeriodId", payload.Response.Content.CyclePeriodId);             
                    handleChange({field: "NeedSave", value: false});  
                    showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }
            }
            setIsLoadingChild(false);
        }
    };
    const saveAction = async () => {
        let messages = [];
        if (CyclePeriodData?.CyclePeriodName.length === 0  || CyclePeriodData?.CyclePeriodName  === null || CyclePeriodData?.CyclePeriodName    === undefined) {
            messages.push(GetBusinessLabel("WarningMessage2"));
        }
        if (CyclePeriodData?.PeriodLabelId          === 0  || CyclePeriodData?.PeriodLabelId    === null || CyclePeriodData?.PeriodLabelId      === undefined) {
            messages.push(GetBusinessLabel("WarningMessage3"));
        }            
        if (CyclePeriodData?.PeriodStatusId         === 0  || CyclePeriodData?.PeriodStatusId   === null || CyclePeriodData?.PeriodStatusId     === undefined) {
            messages.push(GetBusinessLabel("WarningMessage4"));
        }
        if (!compareInitFinDate(CyclePeriodData?.StartDate, CyclePeriodData?.EndDate)) {
            messages.push((GetBusinessLabel("WarningMessage4") ?? "").replace("$placeholder", CyclePeriodData?.CyclePeriodName));
        }
        if (messages.length > 0) {
            showModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }        
        else {
            await handleSave();
        }
    };
    const handleDelete = async () => {
        if (CyclePeriodData?.CycleId !== 0 && CyclePeriodData?.CyclePeriodId !== 0) {
            setIsLoadingChild(true);
            let payload = await deleteCyclePeriod(CyclePeriodData);
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    Remove(Index);
                    showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }
            }
            setIsLoadingChild(false);
        }
    };
    const deleteAction = async () => {
        if (CyclePeriodData?.CycleId !== 0 && CyclePeriodData?.CyclePeriodId !== 0) {
            await showModal(
                <ModalContentGoAction 
                    Message={GetSystemLabel("WarningQuestionProceed")}
                    Action={async () => {
                        await hideModal();
                        await handleDelete();
                        Remove(Index);
                    }}
                />
            );
        }
        else {
            Remove(Index);
        }
    }; 

    useEffect(() => {
        setIsLoading(false);
    }, [PeriodLabelList, StatusList, CyclePeriodData]);

    return(
        <React.Fragment>
            <NeedSaveBlock Boolean={CyclePeriodData?.NeedSave}/>
            <div className={[Style.row, Style.border_bottom, Style.pt_3].join(" ")}>
                {isLoadingChild? 
                    <div className={[Style.col_1, Style.d_flex, Style.align_items_center, Style.justify_content_middle].join(" ")}>
                        <SpinnerSmall/>
                    </div>
                :
                    <React.Fragment>
                        <div className={[Style.col_1, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                            <div onClick={() => {deleteAction();}} style={{width: '1.0rem', height: 'auto'}} className={[Style.icon, Style.clickable, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                </svg>
                            </div>
                        </div>
                        {CyclePeriodData?.CyclePeriodId !== 0?
                            <div className={[Style.col_1, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                                <div onClick={() => {saveAction();}} style={{width: '1.5rem', height: 'auto'}} className={[Style.icon, Style.clickable, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                                    <svg viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 237.3C544 220.3 537.3 204 525.3 192L448 114.7C436 102.7 419.7 96 402.7 96L160 96zM192 192C192 174.3 206.3 160 224 160L384 160C401.7 160 416 174.3 416 192L416 256C416 273.7 401.7 288 384 288L224 288C206.3 288 192 273.7 192 256L192 192zM320 352C355.3 352 384 380.7 384 416C384 451.3 355.3 480 320 480C284.7 480 256 451.3 256 416C256 380.7 284.7 352 320 352z"/>
                                    </svg>
                                </div>
                            </div>   
                        :
                            null
                        }
                    </React.Fragment>                 
                }                                
                <div className={[Style.col].join(" ")}>
                    <span className={[Style.text_body, Style.fs_8, Style.px_3, Style.text_wrap].join(" ")}>
                        {CyclePeriodData?.CyclePeriodName}
                    </span>
                </div>
                <div className={[Style.col_1, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                    <div onClick={toogleOpen} style={{width: '1.5rem', height: 'auto'}} className={[Style.icon, Style.clickable, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <AccordionIcon direction={"Y"} value={isOpen}/>
                        </svg>
                    </div>
                </div>
            </div>
            <div className={[isOpen ? Style.sidebar_animation_open : Style.sidebar_animation_close].join(" ")}>
                {isLoading? 
                    <React.Fragment>
                        <div className={Style.overflow_hidden}>
                            <div className={Style.py_5}>
                                <Spinner/>
                            </div>
                        </div>
                    </React.Fragment>
                :
                    <React.Fragment>
                        <div className={[Style.px_3].join(" ")}>
                            {/* Period Selection */}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                        {GetBusinessLabel("PeriodDescription")}{"*"}
                                    </span>
                                </div>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <SearchableDropdownList    
                                        placeholder={GetBusinessLabel("Period")}                                
                                        listOfItems={
                                            PeriodLabelList && Array.isArray(PeriodLabelList)
                                            ? 
                                                PeriodLabelList.map((d) => ({ value: d.PeriodLabelId, label: d[`PeriodLabelName${GetAppLang()}`]}))
                                            : 
                                                null
                                        }
                                        style={{ width: "100%" }}  
                                        className={Style.antd_custom_select}                               
                                        popupClassName={Style.antd_custom_select}                              
                                        onChange={(event) => {
                                            handleChange({field: "PeriodLabelId",   value: event});
                                            const len = PeriodLabelList?.length;
                                            for(let i = 0; i < len; i++) {
                                                if (event == PeriodLabelList[i].PeriodLabelId) {
                                                    handleChange({field: "CyclePeriodName", value: PeriodLabelList[i].PeriodLabelNamePt});
                                                    handleChange({field: "NeedSave", value: true});
                                                    break;
                                                }
                                            }                                            
                                        }}
                                        value={CyclePeriodData.PeriodLabelId > 0 ? parseInt(CyclePeriodData.PeriodLabelId) : undefined}
                                    />
                                </div>
                            </div>

                            <div className={[Style.py_2].join(" ")}/>

                            {/* Status Selection */}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                        {GetSystemLabel("Status")}{"*"}
                                    </span>
                                </div>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>                                
                                    <SearchableDropdownList    
                                        placeholder={GetSystemLabel("Status")}      
                                        listOfItems={
                                            StatusList && Array.isArray(StatusList)
                                            ? 
                                                StatusList?.map((d) => ({ value: d.StatusId, label: d.StatusNamePt }))
                                            : 
                                                null
                                        }
                                        style={{ width: "100%" }}  
                                        className={Style.antd_custom_select}                               
                                        popupClassName={Style.antd_custom_select}                              
                                        onChange={(event) => {            
                                            handleChange({field: "PeriodStatusId", value: event});
                                            handleChange({field: "NeedSave", value: true});
                                        }}
                                        value={CyclePeriodData?.PeriodStatusId > 0 ? parseInt(CyclePeriodData?.PeriodStatusId) : undefined}
                                    />
                                </div>
                            </div>                    

                            <div className={[Style.py_2].join(" ")}/>
                            
                            {/* Start Period Picker */}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                        {GetBusinessLabel("PeriodStartDate")}{"*"}
                                    </span>
                                </div>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <DatePicker
                                        mode="datetime" 
                                        showTime
                                        inputReadOnly
                                        needConfirm
                                        value={
                                            CyclePeriodData ? 
                                                CyclePeriodData.StartDate !== null ?
                                                    DateFromIsoString(CyclePeriodData.StartDate)
                                                :
                                                    getDateNow()
                                            : 
                                                null
                                        }
                                        placeholder={GetBusinessLabel("SelectDateLabel0")}
                                        className={[Style.mt_2].join(" ")}
                                        onChange={(date) => {
                                            const value = date ?? setDefaultInitDate();
                                            handleChange({field: "StartDate", value: DateToIsoString(value)});
                                            handleChange({field: "NeedSave", value: true});
                                        }}
                                    />
                                </div>
                            </div>

                            <div className={[Style.py_2].join(" ")}/>
                            
                            {/* End Period Picker */}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                        {GetBusinessLabel("PeriodEndDate")}{"*"}
                                    </span>
                                </div>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <DatePicker
                                        mode="datetime" 
                                        showTime
                                        inputReadOnly
                                        needConfirm                                        
                                        value={
                                            CyclePeriodData ? 
                                                CyclePeriodData.EndDate !== null ?
                                                    DateFromIsoString(CyclePeriodData.EndDate)
                                                :
                                                    DateFromIsoString(getDateNow())
                                            : 
                                                null
                                        }
                                        placeholder={GetBusinessLabel("SelectDateLabel0")}
                                        className={[Style.mt_2].join(" ")}
                                        onChange={(date) => {
                                            const value = date ?? setDefaultInitDate();
                                            handleChange({field: "EndDate", value: DateToIsoString(value)});
                                            handleChange({field: "NeedSave", value: true});
                                        }}
                                    />
                                </div>
                            </div>                   

                            <div className={[Style.py_2].join(" ")}/>

                            {/* Observation */}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                        {GetSystemLabel("Observation")}
                                    </span>
                                </div>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                                    <InputGeneral 
                                        value={CyclePeriodData?.CyclePeriodObservation}
                                        className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                        onChange={(event) => {
                                            handleChange({field: "CyclePeriodObservation", value: q3x_FunData(event.target.value)});
                                            handleChange({field: "NeedSave", value: true});
                                        }}
                                        placeholder={GetSystemLabel("Observation")}
                                        maxLength={500}
                                        autoSize={true}
                                    />                            
                                </div>
                            </div>  
                            {/* Item length*/}
                            <div className={Style.row}>
                                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                                    <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{CyclePeriodData?.CyclePeriodObservation?.length} {GetSystemLabel("of")} 500 {GetSystemLabel("Characters")}.</span>
                                </div>
                            </div>

                        </div>
                    </React.Fragment>
                }
            </div>        
        </React.Fragment>
    );

});
const CyclePeriodList               = React.memo(({...setProps}) => {
    const {
        StatusList,
        PeriodLabelList,
        CyclePeriodList,
        SetCyclePeriodData,
        Add,
        Remove,
    }                                                            = setProps;

    useEffect(() => {
    }, [PeriodLabelList, CyclePeriodList]);

    return(
        <React.Fragment>
            {
                CyclePeriodList && Array.isArray(CyclePeriodList) ? CyclePeriodList.map((d, i) => (
                    <CyclePeriodEdit 
                        Index={i} 
                        StatusList={StatusList} 
                        PeriodLabelList={PeriodLabelList}
                        CyclePeriodData={d} 
                        SetCyclePeriodData={SetCyclePeriodData} 
                        Remove={Remove}
                    />
                ))
            :
                null
            }
            <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_end, Style.pt_3].join(" ")}>                
                <div onClick={() => {Add();}} style={{width: '1.8rem', height: 'auto'}} className={[Style.icon, Style.clickable, Style.p_1, Style.text_center].join(" ")}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                        <path d="M352 128C352 110.3 337.7 96 320 96C302.3 96 288 110.3 288 128L288 288L128 288C110.3 288 96 302.3 96 320C96 337.7 110.3 352 128 352L288 352L288 512C288 529.7 302.3 544 320 544C337.7 544 352 529.7 352 512L352 352L512 352C529.7 352 544 337.7 544 320C544 302.3 529.7 288 512 288L352 288L352 128z"/>
                    </svg>
                </div>
            </div>
        </React.Fragment>
    );
});
const CycleEdit                     = React.memo(({...setProps}) => {
    const {
        StatusList,
        PeriodLabelList,
        CycleData,
        fetchCycleList,
    }                                                            = setProps;
    const [ isLoading,       setIsLoading]                       = useState(true);
    const [ cycleObj,         setCycleObj]                       = useState(null);
    const { showToastMessage            }                        = useToastMessage();
    const { showSideContent, hideSideContent        }            = useSideContent();
    const { showModal, hideModal                    }            = useModal();
    const draftKey                                                = `CycleEdit-${CycleData?.CycleId ?? 0}`;

    useEditDraftAutoSave({
        draftKey,
        data:     cycleObj,
        needSave: cycleObj?.NeedSave,
    });

    const handleSave        = async ()  => {
        setIsLoading(true);
        let payload = await updateCycle(cycleObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                setCycleObj(prev => ({
                    ...prev,
                    NeedSave: false,
                    CycleId: payload.Response.Content.CycleId,
                    CyclePeriods: prev.CyclePeriods.map((period, index) => ({
                        ...period,
                        NeedSave: false,
                        CycleId: payload.Response.Content.CycleId,
                        CyclePeriodId: payload.Response.Content.CyclePeriods[index].CyclePeriodId,
                    }))
                }));
                clearEditDraft();
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const saveAction        = async ()  => {
        let messages = [];
        if (cycleObj?.CycleName?.length === 0   || cycleObj?.CycleName === null || cycleObj?.CycleName === undefined) {
            messages.push(GetBusinessLabel("WarningMessage1"));
        }
        if (cycleObj?.CycleYear <= 0            || cycleObj?.CycleYear === null || cycleObj?.CycleYear === undefined) {
            messages.push(GetBusinessLabel("WarningMessage6"));
        }
        const periodLenght = cycleObj.CyclePeriods.length;
        for(let i = 0; i < periodLenght; i++) {
            if (cycleObj.CyclePeriods[i].CyclePeriodName.length === 0  || cycleObj.CyclePeriods[i].CyclePeriodName  === null || cycleObj.CyclePeriods[i].CyclePeriodName    === undefined) {
                messages.push(GetBusinessLabel("WarningMessage2"));
            }
            if (cycleObj.CyclePeriods[i].PeriodLabelId          === 0  || cycleObj.CyclePeriods[i].PeriodLabelId    === null || cycleObj.CyclePeriods[i].PeriodLabelId      === undefined) {
                messages.push(GetBusinessLabel("WarningMessage7"));
            }            
            if (cycleObj.CyclePeriods[i].PeriodStatusId         === 0  || cycleObj.CyclePeriods[i].PeriodStatusId   === null || cycleObj.CyclePeriods[i].PeriodStatusId     === undefined) {
                messages.push(GetBusinessLabel("WarningMessage4"));
            }     
            if (!compareInitFinDate(cycleObj.CyclePeriods[i].StartDate, cycleObj.CyclePeriods[i].EndDate)) {
                messages.push((GetBusinessLabel("WarningMessage5") ?? "").replace("$placeholder", cycleObj.CyclePeriods[i].CyclePeriodName));
            }
        }
        if (messages.length > 0) {
            showModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave();
            await fetchCycleList();
        }
    };
    const handleDelete      = async ()  => {
        setIsLoading(true);
        let payload = await deleteCycle(cycleObj);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessRemoved")});
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const deleteAction      = async ()  => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {                
                    hideModal();
                    await handleDelete();
                    await fetchCycleList();
                    await hideSideContent();
                }}
            />
        );
    };
    const handleStatus = async () => {
        setIsLoading(true);
        let tmp         = cycleObj;
        tmp.StatusId    = (tmp.StatusId === 1) ? 2 : 1;
        let payload     = await updateCycleStatus(tmp);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                setCycleObj(prev => {
                    return({
                        ...prev,
                        StatusId: tmp.StatusId
                    });
                })
            }
            else {
                showModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
    };
    const statusAction = async () => {
        await showModal(
            <ModalContentGoAction 
                Message={GetSystemLabel("WarningQuestionProceed")}
                Action={async () => {
                    await hideModal();
                    await handleStatus();
                    await fetchCycleList();
                }}
            />
        );
    };    

    const addCyclePeriod    = ()        => {
        const newObject = {
            ...blank_cycle_period_obj,
            CycleId: cycleObj.CycleId,
        };
        setCycleObj(prevState => ({
            ...prevState,
            CyclePeriods: [...prevState.CyclePeriods, newObject]
        }));
    };
    const removeCyclePeriod = (idx)   => {
        setCycleObj(prevState => {
            const updatedItems = prevState.CyclePeriods.filter((_, i) => i !== idx);
            return {
                ...prevState,
                CyclePeriods: updatedItems,
            };
        });
    }

    useEffect(() => {
        if (CycleData) {
            const obj = CycleData;
            const draft = takeEditDraft(`CycleEdit-${obj?.CycleId ?? 0}`);
            setCycleObj(prev => {
                return ({
                    ...prev,
                    ...obj,
                    ...(draft ?? {}),
                })
            });
        }
        else {
            const draft = takeEditDraft(`CycleEdit-${blank_cycle_obj?.CycleId ?? 0}`);
            setCycleObj({...blank_cycle_obj, ...(draft ?? {})});
        }
        setIsLoading(false);
    }, [CycleData]);

    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div className={[Style.px_3].join(" ")}>
                    <NeedSaveBlock Boolean={cycleObj?.NeedSave}/>
                    {/* Year picker */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetBusinessLabel("ReferenceYear")}{"*"}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <DatePicker
                                mode="year" 
                                picker="year"
                                placeholder={GetBusinessLabel("ReferenceYear")}
                                style={{width: '100%'}}
                                value={cycleObj?.CycleYear}
                                onChange={(year) => {
                                    setCycleObj(prev => ({
                                        ...prev,
                                        NeedSave: true,
                                        CycleYear: year,
                                        CycleName: year.toString(),
                                    }));
                                }}
                            />                        
                        </div>
                    </div>     

                    <div className={[Style.py_2].join(" ")}/>

                    {/* Observation */}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <span className={[Style.text_body, Style.fs_8].join(" ")}>
                                {GetSystemLabel("Observation")}
                            </span>
                        </div>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center].join(" ")}>
                            <InputGeneral 
                                value={cycleObj?.CycleObservation}
                                className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                                onChange={(event) => {
                                    setCycleObj(prev => {
                                        return({
                                            ...prev,
                                            NeedSave: true,
                                            CycleObservation : q3x_FunData(event.target.value),
                                        });
                                    });
                                }}
                                placeholder={GetSystemLabel("Observation")}
                                maxLength={500}
                                autoSize={true}
                            />                            
                        </div>
                    </div>  
                    {/* Item length*/}
                    <div className={Style.row}>
                        <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                            <span className={[Style.ms_2, Style.text_body_faded, Style.fs_9].join(" ")}>{cycleObj?.CycleObservation?.length} {GetSystemLabel("of")} 500 {GetSystemLabel("Characters")}.</span>
                        </div>
                    </div>                

                    <div className={[Style.py_3].join(" ")}/>

                    <CyclePeriodList 
                        StatusList={StatusList}
                        PeriodLabelList={PeriodLabelList}
                        CyclePeriodList={cycleObj.CyclePeriods} 
                        SetCyclePeriodData={setCycleObj} 
                        Add={addCyclePeriod} 
                        Remove={removeCyclePeriod}
                    />
                    
                    <div className={[Style.py_5, Style.border_bottom].join(" ")}/>                            
                    
                    <div className={Style.row}>
                        <div className={Style.col_lg}/>
                        {((cycleObj.CycleId !== null) && (cycleObj.CycleId !== undefined) && (cycleObj.CycleId !== 0)) && (
                            <React.Fragment>
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.danger_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.fs_8,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {deleteAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_black].join(" ")}>
                                            {GetSystemLabel("Delete")}
                                        </span>
                                    </div>
                                </div>                        
                                <div className={[Style.col_lg_2].join(" ")}>
                                    <div    className={[Style.d_flex, 
                                                        Style.align_items_center, 
                                                        Style.justify_content_center,
                                                        Style.clickable,
                                                        Style.vanilla_bg, 
                                                        Style.rounded_3, 
                                                        Style.border, 
                                                        Style.shadow_sm, 
                                                        Style.text_body,
                                                        Style.py_3,
                                                        Style.px_5,
                                                        Style.pop_item_animation,
                                                        Style.text_center,
                                                        Style.m_3].join(" ")}
                                            onClick={() => {statusAction();}}
                                    >
                                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                            {cycleObj.StatusId === 1 ?
                                                <React.Fragment>{GetSystemLabel("Deactivate")}</React.Fragment>
                                            :
                                                <React.Fragment>{GetSystemLabel("Activate")}</React.Fragment>
                                            } 
                                        </span>
                                    </div>
                                </div>          
                            </React.Fragment>                  
                        )}
                        <div className={[Style.col_lg_2].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.success_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.fs_8,
                                                Style.text_body,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation,
                                                Style.m_3].join(" ")}                                    
                                    onClick={() => {saveAction();}}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")}
                                </span>                                
                            </div>
                        </div>                        
                    </div>  
                </div>
            </React.Fragment>
        
    );

});
const CycleContent                  = ({...setProps}) => {
    const { ContentType, 
            StatusList,
            SearchStatus,
            SetSearchStatus,
    }                                                         = setProps;
    // Mount State                
    const [isReady, setIsReady]                               = useState(false);     
    // Loading State                  
    const [ isLoading,  setIsLoading]                         = useState(true);  
    const [rowData,     setRowData]                           = useState([]);   
    const [searchText,  setSearchText]                        = useState('');
    const [periodLabelList, setPeriodLabelList]               = useState(null);
    const { showSideContent, hideSideContent        }         = useSideContent();    
    const { showModal, hideModal                    }         = useModal();

    const fetchPeriodLabelList      = async () => {
        try {
            let payload = await getPeriodLabelList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setPeriodLabelList(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const fetchCycleList            = async () => {
        try {
            let payload = await getCycleList(SearchStatus);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                    setIsLoading(false);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    const gridContext               = useMemo(() => ({
        isLoading,
        setIsLoading,
        StatusList,
        periodLabelList,
        fetchCycleList: fetchCycleList,
    }), [StatusList, periodLabelList]);

    const columnDefs                = useMemo(() => [
        {
            headerName: GetBusinessLabel("TableHeaderCycleData"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true,                        
                    headerName: GetSystemLabel("Edit"),                     
                    field: GetSystemLabel("Edit"),
                    cellRenderer: CycleEditBtn,
                    cellClass: [Style.table_text_center].join(" "), 
                    headerClass: Style.table_header_center, 
                    flex: 0,
                },
                { hide: false,lockVisible: true,                        headerName: GetSystemLabel("Reference"),                 field: "CycleYear"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Name"),                       field: "CycleName"                  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Observation"),                 field: "CycleObservation"           ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,        
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Status"),                     field: `StatusName${GetAppLang()}`  ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}  ,                                                                
            ]
        },             
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("Identifier"),             field: "CycleId"                    ,filter: true , flex: 0, headerClass: Style.table_header_center, cellClass: [Style.table_text_center].join(" "),}    ,                    
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedBy"),                 field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedBy"),             field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open', headerName: GetSystemLabel("CreatedDate"),            field: "CreatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                         headerName: GetSystemLabel("UpdatedDate"),        field: "UpdatedDate"                ,cellRenderer: DisplayGridDatetime, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
            ]
        },               
    ].filter(Boolean), []);    

    const NewItem                   = () => {
        const obj_copy = JSON.parse(JSON.stringify(blank_cycle_obj));
        showSideContent({
            component: CycleEdit,
            props: {
                fetchCycleList: fetchCycleList,
                StatusList: StatusList, 
                PeriodLabelList: periodLabelList,
                CycleData: obj_copy,
            },
            overlay: true,
        });        
    };

    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            fetchCycleList();
            fetchPeriodLabelList();
        }
    }, [ContentType, isReady, periodLabelList, StatusList]);

    return (
        <React.Fragment>
            <div>
                <p className={[Style.fs_6, Style.text_body, Style.fw_semibold].join(" ")}>
                    {GetBusinessLabel("CyclePageHeader")}
                </p>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_content_start, Style.pt_1, Style.pb_4].join(" ")}>
                    {StatusList ? 
                        <StatusFilter
                            Main={{
                                keyAttribute: `StatusId`,
                                keyAttributeName: `StatusName${GetAppLang()}`,
                                list: StatusList, 
                            }}
                            Manager={{
                                keyAttribute: `StatusIds`,
                                state: SearchStatus,
                                setState: SetSearchStatus,
                            }}
                            Action={fetchCycleList}
                        />
                    :
                        <SpinnerSmall/>
                    }
                </div>
            </div>
            {isLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control, Style.pb_2].join(" ")}>
                        <div style={{ width: "5.0rem", maxWidth: "10.0rem" }}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.vanilla_bg, 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm, 
                                                Style.py_2,
                                                Style.pop_item_animation].join(" ")}
                                    onClick={() => {NewItem();}}
                            >
                                <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                    {GetSystemLabel("New")}
                                </span>                                
                            </div>                          
                        </div>
                    </div>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={rowData}
                                searchText={searchText}
                                setSearchText={setSearchText}
                                gridContext={gridContext}
                            />                     
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};
//#endregion

export const ConfigPage          = () => {
    const [ contentType,    setContentType          ]   = useState(1);
    const [ mount,          setMount                ]   = useState(false);
    const [ statusList,     setStatusList           ]   = useState(null);
    const { showLoader,     hideLoader              }   = useLoader();
    const [ access,         setAccess               ]   = useState(false);
    const [searchStatus,    setSearchStatus         ]   = useState({StatusIds: []});    

    const fetchStatusList = async () => {
        try {
            let data = await getSystemStatusList({type: 1});
            if (data) {
                setStatusList(data);
            }
        }
        catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if(!mount) {
            if (ValidateBusinessRules("B")) {
                setAccess(true);
                setMount(true);
                fetchStatusList();
            }
            setMount(true);
        }
    }, [contentType]);

    return (
        access ?
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
                <div className={[Style.d_flex, Style.align_items_center, Style.justify_page_control].join(" ")}>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(1)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 1) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 1) ? Style.text_decoration_underline   : null, 
                                    (contentType === 1) ? Style.fw_semibold                 : null,
                                    (contentType === 1) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetBusinessLabel("Cycles")}
                            </span>
                        </div>                            
                    </div>
                    <div style={{ width: "10.0rem", maxWidth: "20.0rem" }}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.vanilla_bg,
                                            Style.rounded_3,
                                            Style.shadow_sm,
                                            Style.clickable,
                                            Style.py_3,
                                            Style.mx_1,
                                            Style.pop_item_animation].join(" ")}
                            onClick={() => setContentType(2)}
                        >
                            <span 
                                className={[                                
                                    (contentType === 2) ? Style.text_body_active            : Style.text_body, 
                                    (contentType === 2) ? Style.text_decoration_underline   : null, 
                                    (contentType === 2) ? Style.fw_semibold                 : null,
                                    (contentType === 2) ? Style.fs_6                        : Style.fs_8,
                                ].join(" ")}
                            >
                                {GetBusinessLabel("Periods")}
                            </span>
                        </div>                                                        
                    </div>
                </div>
            {
                contentType === 1? 
                    <React.Fragment>
                        <CycleContent                 
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                        />
                    </React.Fragment>
                : 
                contentType === 2? 
                    <React.Fragment>
                        <PeriodContent
                            ShowLoader={showLoader}
                            HideLoader={hideLoader}
                            ContentType={contentType}
                            StatusList={statusList}
                            SearchStatus={searchStatus}
                            SetSearchStatus={setSearchStatus}
                        />
                    </React.Fragment>
                :
                    null
            }
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};